const statusTypes = {
  UnSet: {
    id: 0,
    name: 'Unset',
  },
  Aceptada: {
    id: 1,
    name: 'Aceptada',
  },
  Rechazada: {
    id: 2,
    name: 'Rechazada',
  },
  Pendiente: {
    id: 3,
    name: 'Pendiente',
  },
  Cargado: {
    id: 4,
    name: 'Cargado',
  },
};

export default statusTypes;
